module.exports = __webpack_public_path__ + "img/qr_code_new.17a5e765.jpeg";